var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCouponImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 13.3337C22.2667 13.3337 23.16 13.1603 24 12.867V24.0003C24 24.7076 23.7191 25.3858 23.219 25.8859C22.7189 26.386 22.0406 26.667 21.3333 26.667H2.66667C1.2 26.667 0 25.467 0 24.0003L0 5.33365C0 4.62641 0.280952 3.94813 0.781049 3.44804C1.28115 2.94794 1.95942 2.66699 2.66667 2.66699H13.8C13.5067 3.50699 13.3333 4.40032 13.3333 5.33365H2.66667L2.66667 24.0003H21.3333V13.3337ZM12.3867 12.0537L17.1067 15.7203L13.96 18.3337L18.6667 22.0003V12.867C17.1733 12.3337 15.88 11.3737 14.9467 10.1337L12.3867 12.0537ZM20 4.00032H16V6.66699H20V10.667H22.6667V6.66699H26.6667V4.00032H22.6667V0.000320435H20V4.00032Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCouponImage);
export default __webpack_public_path__ + "static/media/no_coupon_image.fb845f43328d05b9ba4b62280946f8a7.svg";
export { ForwardRef as ReactComponent };